import { Lang } from '@common/typescript/objects/Lang';

export const LanguageNames = {
	[Lang.En]: 'English',
	[Lang.Ru]: 'Russian',
	[Lang.De]: 'Deutsch',
	[Lang.Es]: 'Spanish',
	[Lang.Fr]: 'French',
	[Lang.It]: 'Italian',
};

export const LanguageKeys = {
	[Lang.En]: 'en',
	[Lang.Ru]: 'ru',
	[Lang.De]: 'de',
	[Lang.Es]: 'es',
	[Lang.Fr]: 'fr',
	[Lang.It]: 'it',
};
